import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { pageStatistics } from '@ifeng-fe/mobile_statistics';
import { getQrCode } from '@src/public/hooks/qrCode';
import { getQuery, setAppQuery } from '@src/public/utils/url';
import { linkBase } from '@src/mobile/components/Link';
import { isGrounds } from '@src/public/utils/app';
import { useWeixinLogin } from '@src/public/hooks/useWeixinLogin';
import Page404 from '@src/mobile/components/Page404';
import styles from './index.css';
import { ListStore } from '../store';
import { changeEventList, changeEventListType } from '../utils';
import { getNodePosition } from '../service';
import Spin from '../Spin';
import Nav from '../Nav';
import Main from '../Main';
import Bottom from '../Bottom';
import Brand from '../Brand';
import ShareLongImg from '../ShareLongImg';

const Wrap = ({ content }) => {
    const { id, live, list2Ad } = content;

    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const { page, size, party, highlights, order, pageInitDone, pageOnline, showShareLongImg } = listStates;
    const isFromHws = window.location.search.includes('from=hms');
    
    useEffect(() => {
        if (live) {
            changeListStates({ live });
        }
        if (list2Ad) {
            changeListStates({ list2Ad });
        }
    }, []);

    // page统计
    useEffect(() => {
        pageStatistics({
            behavior: 'page',
            id: `timeline_${id}`,
            url: window.location.href,
            // ref: window?.grounds?.getPageInfo?.()?.getRef?.() || '',
            type: 'newsgroup',
            showtype: window?.grounds?.getPageInfo?.()?.getShowtype?.() || '',
            rnum: window?.grounds?.getPageInfo?.()?.getRnum?.() || '',
            pagetype: 'newsgroup',
        });
    }, []);

    // 获取用于端内卡片分享的网址二维码图片链接
    useEffect(() => {
        if (isGrounds) {
            // 分享链接，示例：https://news.ifeng.com/loc/timeline/event/6904615406007231322
            
            const shareUrl = setAppQuery(`https://ishare.ifeng.com/loc/timeline/event/${id}`);

            getQrCode({ url: shareUrl })
                .then(qrcode => {
                    changeListStates({ qrcode });
                })
                .catch(e => {
                    console.error(e);
                });
        }
    }, []);

    // 从接口初始化数据的函数
    const pageInit = async () => {
        const msgSubjectId = getQuery(window.location.href, 'msgSubjectId');
        let position = -1;

        try {
            if (msgSubjectId) {
                const res = await getNodePosition(msgSubjectId);

                position = parseInt(res.position);
            }
        } catch (e) {
            console.error(e);
        }

        if (position === -1) {
            const { title } = await changeEventList({
                query: { id, page, size, party, highlights, order },
                type: changeEventListType.init,
                changeData: changeListStates,
            });

            document.title = title;
        } else {
            const initSize = Math.ceil((position + 1) / size) * size;
            const { title } = await changeEventList({
                query: { id, page, size, party, highlights, order, initSize },
                type: changeEventListType.init,
                changeData: changeListStates,
            });

            document.title = title;
        }
    };

    // 从接口初始化数据
    useEffect(() => {
        pageInit()
            .catch(e => {
                console.error(e);
                changeListStates({ pageOnline: false });
            })
            .finally(() => {
                changeListStates({ pageInitDone: true });
            });
    }, []);

    // 在微信内打开页面，如有查询参数code则根据code获取token并存到cookie里
    useWeixinLogin();

    return (
        <>
            {pageInitDone ? (
                <>
                    {pageOnline ? (
                        <>
                            <div className={styles.wrap}>
                                {!isGrounds && !isFromHws ? <Brand /> : null}
                                <Nav />
                                <Main />
                                <Bottom />
                            </div>
                            {showShareLongImg ? <ShareLongImg /> : null}
                        </>
                    ) : (
                        <Page404 text={'服务器开小差了'} />
                    )}
                </>
            ) : (
                <div className={styles.fullScreen}>
                    <Spin />
                </div>
            )}
        </>
    );
};

Wrap.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Wrap);
